import { createSelector } from '@reduxjs/toolkit';
export const selectUserState = state => state.user;
export const selectScopes = createSelector(selectUserState, user => user.scopes);
export const selectUserEmail = createSelector(selectUserState, user => user.email);